// export const Telco = "mobilink";
// export const Telco = "ufone";
// export const Telco = "zain";
 export const Telco = "cricwick";
// export const Telco = "zong";

